export default {
  setAttrs ({ commit }, model) {
    commit('setModel', model)
    commit('setName', model.get('name'))
    commit('setSmallAction', model.get('smallAction'))
    commit('setAlternateAction', model.get('alternateAction'))
    commit('setDescription', model.get('description'))
  }
}
